export default "__VITE_ASSET__C7L5Y4oI__"